import { site } from "@/content/liane-site.ar";
import { useReveal } from "@/hooks/use-reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export function FAQ() {
  const reveal = useReveal<HTMLDivElement>();

  return (
    <section id="faq" className="py-16 lg:py-24">
      <div ref={reveal.ref} className={`container-liane ${reveal.className}`}>
        <h2 className="text-center text-2xl font-bold text-l-primary sm:text-3xl lg:text-4xl">
          {site.faq.title}
        </h2>

        <Accordion type="single" collapsible className="mx-auto mt-9 max-w-3xl">
          {site.faq.items.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`item-${i}`}
              className="mb-3 overflow-hidden rounded-2xl border border-l-border bg-l-card px-5"
            >
              <AccordionTrigger className="py-5 text-start text-base font-bold text-l-primary hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-start text-sm leading-7 text-l-muted-foreground sm:text-base">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
